<sc-button [id]="'nueva_cotizacion'" type="primary" (onClick)="handleNewQuotation()" [loading]="isLoading">
    Nueva cotización
</sc-button>

<div #polizaIframeContainer (show)="insuring" class="poliza-box-container" [ngClass]="iframeState">
    <div class="polizaFrameBG" [ngClass]="iframeState"></div>
    <iframe [src]="iframeSource | safe" [ngClass]="iframeState" class="polizaFrame" title="Contenedor"
        (load)="onPolizaLoaded();" id='polizaIframe' #polizaIframe>
    </iframe>
</div>